import React from 'react';
import PropTypes from "prop-types";
import { Input } from "reactstrap";

const LockableLineItemField = React.forwardRef((props, ref) => {
    function formatLockedValue() {
        if (props.lockedFormatter)
            return props.lockedFormatter(props.value);
        return props.value;
    }

    if (props.isLocked) {
        return <span className={props.className}>{formatLockedValue()}</span>;
    }
    return (
        <Input
            ref={ref}
            className={props.className}
            name={props.name}
            autoFocus={props.autoFocusOnMount}
            onBlur={event => {
                if (props.onBlurHandler)
                    props.onBlurHandler(event);
            }}
            value={props.value}
            {...props.inputProperties}
        />
    );
});

LockableLineItemField.propTypes = {
    isLocked: PropTypes.bool,
    inputProperties: PropTypes.object.isRequired,
    value: PropTypes.string,
    onBlurHandler: PropTypes.func,
    lockedFormatter: PropTypes.func,
    className: PropTypes.string,
    autoFocusOnMount: PropTypes.bool
};

export default LockableLineItemField;
